// hooks
import { useApproveRetrospectiveClaim } from "containers/ApproveRetrospectiveClaim/useApproveRetrospectiveClaim";

// ANT modules
import { Form, Input, Button } from "antd";

// components
import { Head } from "components/molecules/Head/Head";
import PageTitle from "components/molecules/PageTitle/PageTitle";
import Label from "components/atoms/Label/Label";
import Spinner from "components/atoms/Spinner/Spinner";

// styles
import styles from "containers/ApproveRetrospectiveClaim/approveRetrospectiveClaim.module.css";

// constants
import { PageTitles, APPROVE_RETRO_CLAIM as Constants } from "constants/global";

// utils
import getIconOthers from "utils/getIconRetrospectiveClaim";

const ApproveRetrospectiveClaim = () => {
	const componentsProps = useApproveRetrospectiveClaim();

	const { initValues, loading, goBack, proceedToConfirm } = componentsProps;

	return (
		<div className={styles?.root}>
			{loading && <Spinner type="transparent" />}
			<div className={styles?.bg_curve}>{getIconOthers({ icon: "background" })}</div>
			<div className={styles?.bg_frame}>{getIconOthers({ icon: "overlay" })}</div>
			<Head>{PageTitles?.APPROVE_RETROSPECTIVE_CLAIM}</Head>
			<PageTitle showBackIcon={true} title={Constants.PAGE_TITLE} subTitle={Constants.PAGE_SUBTITLE} goBack={goBack} />
			<div className={styles?.main_wrapper}>
				<Form className={styles?.form} layout="vertical">
					<div className={styles?.input_wrapper}>
						<Form.Item
							name={Constants.FIELD_RECEIPT_DATETIME}
							initialValue={initValues?.receipt_datetime}
							label={<Label classes={{ label: styles?.basic_input_label }} label={Constants.RECEIPT_DATETIME} />}
						>
							<Input readOnly disabled className={styles?.basic_input} id={Constants.FIELD_RECEIPT_DATETIME} data-testid={Constants.FIELD_RECEIPT_DATETIME} />
						</Form.Item>

						<Form.Item
							name={Constants.FIELD_OUTLET}
							initialValue={initValues?.outlet_code}
							label={<Label classes={{ label: styles?.basic_input_label }} label={Constants.OUTLET} />}
						>
							<Input readOnly disabled className={styles?.basic_input} id={Constants.FIELD_OUTLET} data-testid={Constants.FIELD_OUTLET} />
						</Form.Item>
					</div>
					<div className={styles?.input_wrapper}>
						<Form.Item
							name={Constants.FIELD_PURCHASE_AMOUNT}
							initialValue={initValues?.purchase_amount}
							label={<Label classes={{ label: styles?.basic_input_label }} label={Constants.PURCHASE_AMOUNT} />}
						>
							<Input readOnly disabled className={styles?.basic_input} id={Constants.FIELD_PURCHASE_AMOUNT} data-testid={Constants.FIELD_PURCHASE_AMOUNT} />
						</Form.Item>

						<Form.Item
							name={Constants.FIELD_NETT_AMOUNT}
							initialValue={initValues?.net_amount}
							label={<Label classes={{ label: styles?.basic_input_label }} label={Constants.NETT_AMOUNT} />}
						>
							<Input readOnly disabled className={styles?.basic_input} id={Constants.FIELD_NETT_AMOUNT} data-testid={Constants.FIELD_NETT_AMOUNT} />
						</Form.Item>
					</div>
					<div className={styles?.buttons_wrapper}>
						<Button className={styles?.confirm_button} onClick={proceedToConfirm}>
							{Constants.CONFIRM_BUTTON}
						</Button>
						<Button className={styles?.go_back_button} onClick={goBack}>
							{Constants.GOBACK_BUTTON}
						</Button>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default ApproveRetrospectiveClaim;
